<app-side-menu></app-side-menu>
<div class="main fs-main-layout">
  <app-header></app-header>
  <div class="main__content">
    <ng-content></ng-content>
  </div>
</div>
